import React from 'react';
import autobind from 'autobind-decorator';
import {Col, Dropdown, DropdownButton, FormCheck, Row} from 'react-bootstrap';
import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";
import {service as ActivityFeedSubscriptionService} from "../../../Services/ActivityFeedSubscriptionService";
import {Glyphicon} from "../GlyphIcon";

export class ActivityFeedSubscriptionDropDown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: [],
            subscriptions: []
        };
    }

    componentDidMount() {
        Promise.all([
            ActivityFeedFilterService.Get(),
            ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(this.props.ContextNodeId)
        ])
            .then(([filters, subscriptions]) => {
                this.setState({
                    filters: filters.result,
                    subscriptions: subscriptions.result
                });
            });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.ContextNodeId != prevProps.ContextNodeId) {
            ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(this.props.ContextNodeId)
                .then((subscriptions) => {
                    this.setState({
                        subscriptions: subscriptions.result
                    });
                });
        }
    }

    @autobind
    deleteSubscription(id) {
        ActivityFeedSubscriptionService.DeleteActivityFeedSubscription(id)
            .then(() => {
                ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(this.props.ContextNodeId)
                    .then((subscriptions) => {
                        this.setState({
                            subscriptions: subscriptions.result
                        });
                    });
            });
    }

    @autobind
    createSubscription(activityFeedFilterId) {
        ActivityFeedSubscriptionService.CreateActivityFeedSubscription(this.props.ContextNodeId, activityFeedFilterId)
            .then(() => {
                ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(this.props.ContextNodeId)
                    .then((subscriptions) => {
                        this.setState({
                            subscriptions: subscriptions.result
                        });
                    });
            });
    }

    @autobind
    getCheckbox(activityFeedFilterId, checkBoxLabel) {
        let filter = this.state.subscriptions.find((x) => x.activityFeedFilterId == activityFeedFilterId);

        let callback = () => {
            if(filter != null) {
                this.deleteSubscription(filter.activityFeedSubscriptionId);
            } else {
                this.createSubscription(activityFeedFilterId);
            }
        };

        return <FormCheck
            checked={filter != null}
            onChange={callback}
            label={checkBoxLabel}
        />;
    }

    render() {
        return <DropdownButton
            id="ActivityFeedSubscriptionDropDown"
            variant={this.state.subscriptions.length ? "primary" : "default"}
            size="sm"
            align="end"
            title={<span><Glyphicon glyph="plus" /> {this.state.subscriptions.length ? "Subscribed" : "Subscribe"}</span>}
            className="sb-activity-feed-subscription-dropdown"
        >
            {
                this.state.filters.map((x) => {
                    let checkbox = this.getCheckbox(x.activityFeedFilterId, x.name);

                    return <Dropdown.Item key={x.activityFeedFilterId} className="sb-activity-feed-subscription-dropdown-row">
                        {checkbox}
                    </Dropdown.Item>;
                })
            }
            <Dropdown.Divider key="divider" />
            <Dropdown.Item key="all" className="sb-activity-feed-subscription-dropdown-row">
                {this.getCheckbox(null, 'Subscribe All')}
            </Dropdown.Item>
        </DropdownButton>;
    }
}



